import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

const CATS = ["Automotive", "Home & Furniture", "Glass", "Commercial"];

export default function AdminApplicatorServices() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ name: "", category: "Automotive", requires_training: true, requires_certification: true, job_eligibility: true });

  const load = () => api.get("/admin/applicator-services").then(({ data }) => setList(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name) { toast.error("Name required"); return; }
    await api.post("/admin/applicator-services", form);
    toast.success("Service created"); setForm({ ...form, name: "" }); load();
  };
  const toggle = async (s) => { await api.put(`/admin/applicator-services/${s.id}`, { ...s, active: !s.active }); load(); };

  const byCat = list.reduce((a, s) => { (a[s.category] = a[s.category] || []).push(s); return a; }, {});

  return (
    <div className="min-h-screen bg-[#080808]" data-testid="admin-applicator-services-page">
      <Seo title="Admin · Applicator Services" description="Manage applicator service catalogue" />
      <div className="glass"><div className="max-w-[1000px] mx-auto px-5 h-[60px] flex items-center justify-between">
        <Link to="/admin/applicators" className="flex items-center gap-2 text-sm text-gray-300"><ArrowLeft size={16} /> Applicators</Link>
      </div></div>

      <div className="max-w-[1000px] mx-auto px-5 py-10">
        <h1 className="serif-head text-3xl lg:text-4xl mb-6">Applicator Services</h1>

        <div className="hair-border bg-white/[0.02] p-4 mb-8 grid sm:grid-cols-[1fr_auto_auto] gap-3 items-end" data-testid="new-service-form">
          <div><label className="errah-label mb-1 block">Service name</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="new-service-name" className="w-full bg-transparent border border-white/15 px-3 py-2.5 text-sm focus:border-[#C9A45C]" /></div>
          <div><label className="errah-label mb-1 block">Category</label>
            <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="bg-[#111] border border-white/15 px-3 py-2.5 text-sm">{CATS.map((c) => <option key={c}>{c}</option>)}</select></div>
          <button onClick={create} data-testid="create-service-btn" className="inline-flex items-center gap-2 bg-[#C9A45C] text-black px-5 py-2.5 text-sm font-semibold hover:bg-[#E4C987] transition-colors"><Plus size={15} /> Add</button>
        </div>

        {Object.entries(byCat).map(([cat, items]) => (
          <div key={cat} className="mb-6">
            <p className="errah-label gold-text mb-2">{cat}</p>
            <div className="space-y-2">
              {items.map((s) => (
                <div key={s.id} className={`hair-border p-3 flex items-center justify-between ${s.active ? "bg-white/[0.02]" : "bg-white/[0.01] opacity-60"}`} data-testid={`acat-${s.id}`}>
                  <span className="text-sm">{s.name} {!s.active && <span className="text-xs text-red-400">(inactive)</span>}</span>
                  <button onClick={() => toggle(s)} className="text-xs border border-white/20 px-3 py-1.5 hover:bg-white hover:text-black transition-colors">{s.active ? "Deactivate" : "Activate"}</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
